import React, {useRef, useState, useEffect, useCallback} from 'react';

export const useWindows = () => {
    let [ordering, setOrdering] = useState([]);
    const sizeRef = useRef({width: 250, height: 150});

    return {ordering, setOrdering, sizeRef};
};
